/**
 * Ya.Share2: клик по подписи «Поделиться» открывает шторку / дропдаун.
 *
 * @param {ParentNode} [root=document]
 */
export function initShare(root = document) {
  if (!(root instanceof Document) && !(root instanceof Element)) {
    return;
  }

  const host = root instanceof Document ? root.documentElement : root;
  if (!(host instanceof Element) || host.dataset.shareInited === '1') {
    return;
  }
  host.dataset.shareInited = '1';

  root.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const btn = target.closest('.share_bt');
    if (!btn) {
      return;
    }

    const link = btn.parentElement?.querySelector('.ya-share2 .ya-share2__link');
    if (link instanceof HTMLElement) {
      link.click();
    }
  });
}
